import { ItiLink as Link } from 'components';
import { FC } from 'react';
import { LinkProps, Outlet, useLocation, useMatch, useParams, useResolvedPath } from 'react-router-dom';

import 'components/organization/tab-view/tab-view.scss';
import { useAuth } from 'contexts';
import { Role } from 'types';
import './scac-management.scss';

const TabLink: FC<LinkProps & { to: string }> = ({ children, to }) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: `${resolved.pathname}`, end: true });

  return (
    <Link className={match ? 'active-tab tab' : 'tab'} to={to} replace>
      {children}
    </Link>
  );
};

const ScacManagementTabs: FC = () => {
  const { userProfile } = useAuth();
  const location = useLocation();
  const params = useParams();

  if (params.id || params.username || location.pathname.includes('new') || location.pathname.includes('edit')) {
    return <Outlet />;
  }

  return (
    <div id="scac-management" className="page">
      <div className="page-header">
        <h1>SCAC MANAGEMENT</h1>
      </div>
      <div className="page-content h-100">
        <div className="tab-view h-100">
          <div className="tab-bar g-5">
            {[
              Role.ADMIN,
              Role.BILLING_ADMIN,
              Role.BOOKING,
              Role.SENIOR_BOOKING,
              Role.ADMIN_CUSTOMER
            ].includes(userProfile.role) && (
              <TabLink to="/scac-management">
                <h3>CARRIERS</h3>
              </TabLink>
            )}
            <TabLink to="/scac-management/account-rules">
              <h3>ACCOUNT RULES</h3>
            </TabLink>
            {[
              Role.ADMIN,
              Role.BILLING_ADMIN,
              Role.BOOKING,
              Role.SENIOR_BOOKING
            ].includes(userProfile.role) && (
              <TabLink to="/scac-management/location-rules">
                <h3>LOCATION RULES</h3>
              </TabLink>
            )}
          </div>
          <div className="tab-content d-flex flex-column">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScacManagementTabs;
